export const isDiscountUsed = discount =>
  Number(discount?.usage_count || 0) >= 1;

export const canDeleteDiscount = discount => !isDiscountUsed(discount);
